var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsNewHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 20C7.41745 20 5.17578 19.1417 3.27578 17.425C1.37578 15.7083 0.300781 13.5667 0.0507812 11H2.07578C2.32578 13.0167 3.20495 14.6875 4.71328 16.0125C6.22161 17.3375 7.98411 18 10.0008 18C12.2341 18 14.1258 17.225 15.6758 15.675C17.2258 14.125 18.0008 12.2333 18.0008 10C18.0008 7.76667 17.2258 5.875 15.6758 4.325C14.1258 2.775 12.2341 2 10.0008 2C8.56745 2 7.23828 2.35417 6.01328 3.0625C4.78828 3.77083 3.81745 4.75 3.10078 6H6.00078V8H0.200781C0.684115 5.66667 1.84245 3.75 3.67578 2.25C5.50911 0.75 7.61745 0 10.0008 0C11.3841 0 12.6841 0.2625 13.9008 0.7875C15.1174 1.3125 16.1758 2.025 17.0758 2.925C17.9758 3.825 18.6883 4.88333 19.2133 6.1C19.7383 7.31667 20.0008 8.61667 20.0008 10C20.0008 11.3833 19.7383 12.6833 19.2133 13.9C18.6883 15.1167 17.9758 16.175 17.0758 17.075C16.1758 17.975 15.1174 18.6875 13.9008 19.2125C12.6841 19.7375 11.3841 20 10.0008 20ZM12.8008 14.2L9.00078 10.4V5H11.0008V9.6L14.2008 12.8L12.8008 14.2Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNewHistory);
export default __webpack_public_path__ + "static/media/icons_new_history.fe7f63f4.svg";
export { ForwardRef as ReactComponent };